import React from 'react'
import styled from 'styled-components'
import VisaImage from '../../../../../../assets/img/visa_icon.png'
import MastercardImage from '../../../../../../assets/img/mastercard_icon.png'
import AmexImage from '../../../../../../assets/img/amex_icon.png'
import DinersImage from '../../../../../../assets/img/diners_icon.png'
import { device } from '../../../../../../config/theme/breakpoints'

const ContainerPayments = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-around;
  align-self: center;
  padding-left: 15px;
  margin-top: 10px;
  margin-bottom: 15px;

  > div {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0 12px 0 0;
  }

  > div img{
    width: 30px;
  }

  @media ${device.tablet}{
    align-self: flex-start;
  }
`

const listMethods = [
  {
    id: 1,
    icon: VisaImage
  },
  {
    id: 2,
    icon: MastercardImage
  },
  {
    id: 3,
    icon: AmexImage
  },
  {
    id: 4,
    icon: DinersImage
  }
]

const ListPaymentFooter: React.FunctionComponent = () => {
  return (
    <ContainerPayments>
        {listMethods.map(method => (
          <div>
            <img key={method.id} src={method.icon} alt='icons'/>
          </div>
        ))}
    </ContainerPayments>
  )
}

export default ListPaymentFooter